import React, { useState } from "react";
import { useAppSelector } from "../../../hooks/customReduxHooks";
import { useHandlerCDNMultimedia } from "../../../hooks/useHandlerCDNMultimedia";
import { ContainerAllImages, DescriptionContainer, GalleryWithDescriptionContainer, MainImageContainer, TitleContainer, } from "./GalleryWithDescriptionStyled";
export var GalleryWithDescription = function (_a) {
    var product = _a.product, selected = _a.selected;
    var _b = useState(selected), multimediaSelected = _b[0], setMultimediaSelected = _b[1];
    var empresaData = useAppSelector(function (state) { var _a; return (_a = state.empresa) === null || _a === void 0 ? void 0 : _a.empresaData; });
    var getCDNMultimedia = useHandlerCDNMultimedia().getCDNMultimedia;
    var selectImage = function (multimedia) {
        setMultimediaSelected(multimedia);
    };
    return (product && (React.createElement(GalleryWithDescriptionContainer, null,
        React.createElement(MainImageContainer, null, product.multimedia
            .filter(function (multimedia) { return multimedia.type === "imagen"; })
            .map(function (multimedia) { return (React.createElement("img", { key: multimedia.id, src: getCDNMultimedia({
                path: multimedia.url,
                settings: empresaData.configuraciones,
                size: "700x700",
            }), alt: multimedia.name, className: multimedia.id === multimediaSelected.id ? "selected" : "" })); })),
        React.createElement(DescriptionContainer, null,
            React.createElement(TitleContainer, null, "".concat(product.title, " ").concat(product.subtitle)),
            React.createElement(ContainerAllImages, null, product.multimedia
                .filter(function (multimedia) { return multimedia.type === "imagen"; })
                .map(function (multimedia) { return (React.createElement("li", { key: multimedia.id, onClick: function () { return selectImage(multimedia); }, className: multimedia.id === (multimediaSelected === null || multimediaSelected === void 0 ? void 0 : multimediaSelected.id) ? "selected" : "" },
                React.createElement("img", { src: getCDNMultimedia({
                        path: multimedia.url,
                        settings: empresaData.configuraciones,
                        size: "150x150",
                    }), alt: multimedia.name }))); }))))));
};
